module.exports = __webpack_public_path__ + "img/dark-green-square-table-4.5d8b5ddb.png";